import { Pinch } from '../../../plugins/gestures.js';
export default Pinch;